import { useEffect } from "react";

import RefreshButton from "../../../shared/ui/Refresh.Button";
import TableNew, { CELL_TYPES } from "../../../shared/Table";
import { TableCellAccountRedirect } from "../../../shared/Table/components/Cell";
import { loanStages } from "../../../shared/dictionary/enums";
import TableCellRestRepayActions from "./TableCellRestRepayActions";
import { restRepaymentConnector } from "../../../services/loan/restRepayments/connector";
import loanConnector from "../../../services/loan/connector";
import LoanDetails from "../../loans/components/LoanDetails/LoanDetails.Component";
import accountInfosConnector from "../../../services/users/accountInfo/connector";

export const RestRepaymentPage = ({
  restRepayments,
  loadRestRepayments,
  restRepayLoan,
  ...props
}) => {
  useEffect(() => {
    if (!restRepayments.fetched) loadRestRepayments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    {
      key: "BorrowerId",
      label: "Get ssn",
      filter: false,
      visible: true,
      type: CELL_TYPES.ssn,
    },
    { key: "Id", label: "Id", visible: true, type: CELL_TYPES.text },
    {
      key: "LastCalculatedDebt",
      label: "Last Calculated Debt ",
      visible: true,
      type: CELL_TYPES.money,
    },
    {
      key: "PaidOut",
      label: "Paid Out ",
      visible: true,
      type: CELL_TYPES.date,
    },
    {
      key: "ExternalLoanId",
      label: "External Loan Id ",
      visible: true,
      type: CELL_TYPES.text,
    },
    {
      key: "Amount.Amount",
      label: "Amount ",
      visible: true,
      type: CELL_TYPES.money,
    },
    { key: "OCR", label: "OCR ", visible: true, type: CELL_TYPES.text },
    {
      key: "LoanTerm",
      label: "LoanTerm ",
      visible: true,
      type: CELL_TYPES.number,
    },
    {
      key: "CreditStage",
      label: "Loan stage",
      visible: true,
      enumDict: loanStages,
      type: CELL_TYPES.enum,
    },
    {
      key: "Term",
      label: "Original Term",
      visible: true,
      type: CELL_TYPES.number,
    },
    {
      key: "NominalInterest.Value",
      label: "Interest",
      visible: true,
      type: CELL_TYPES.percentage,
    },
    {
      key: "IntermediationFee.Amount",
      label: "Intermediation Fee",
      visible: true,
      type: CELL_TYPES.money,
    },
    {
      key: "TotalPaid.Amount",
      label: "Paid amount",
      visible: true,
      type: CELL_TYPES.money,
    },
    {
      key: "BorrowerId",
      label: "Borrower Id",
      visible: false,
      type: CELL_TYPES.text,
      renderer: (value) => {
        return <TableCellAccountRedirect value={value} type={"accountId"} />;
      },
    },
    {
      key: "actions",
      label: "Actions",
      visible: true,
      filter: false,
      renderer: (value, item) => {
        return (
          <TableCellRestRepayActions
            restRepayLoan={restRepayLoan}
            value={value}
            item={item}
            key={item.id}
          />
        );
      },
    },
  ];

  return (
    <div className="loans-layout body-height content-padding">
      <RefreshButton onRefreshClick={loadRestRepayments} />
      <h3>Rest Repayments</h3>
      {!restRepayments.fetched ? (
        <div> Loading... </div>
      ) : (
        <div>
          <br />
          <TableNew
            columns={columns}
            items={restRepayments.data}
            actionColumnWidth={200}
            showDetails={true}
            tableKey={"rest-repayments"}
            selectId={"Id"}
            detailsRenderer={(item) => {
              return <LoanDetails {...props} item={item} />;
            }}
          />
        </div>
      )}
    </div>
  );
};

export default restRepaymentConnector(
  loanConnector(accountInfosConnector(RestRepaymentPage)),
);
